// @flow
import { setNotificationUsers } from 'pages/Slices/packetSlice'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'

type Props = {
  children: Function,
}

function FormBuilderSettingsNotificationsPacketConsumer({
  children,
}: Props): React.Node {
  const { notification_users: notificationUsers } = useSelector(
    (state) => state.packet
  )

  const dispatch = useDispatch()

  return children({
    notificationUsers: notificationUsers || [],
    setNotificationUsers: (payload) => dispatch(setNotificationUsers(payload)),
  })
}

export default FormBuilderSettingsNotificationsPacketConsumer
